module.exports = __webpack_public_path__ + "static/img/追觅洗地机T40系列.6addba30.png";